const YEAR = new Date().getFullYear();

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-[#1a1a1a] bg-[#050505]"
    >
      {/* Giant brand mark watermark */}
      <div className="relative overflow-hidden px-6 md:px-12 lg:px-16 pt-16 md:pt-24 pb-4">
        <div className="relative">
          <p
            aria-hidden
            className="font-display uppercase leading-[0.8] text-[18vw] text-outline select-none"
          >
            Insight Media
          </p>
          <img
            src="https://customer-assets.emergentagent.com/job_cinematic-minimal-1/artifacts/3kurmq5r_IMG_6229.jpg"
            alt=""
            aria-hidden
            className="pointer-events-none select-none absolute inset-0 m-auto h-[60%] w-auto object-contain opacity-[0.18] mix-blend-screen"
          />
        </div>
      </div>

      <div className="px-6 md:px-12 lg:px-16 py-12 grid grid-cols-1 md:grid-cols-12 gap-10 border-t border-[#1a1a1a] mt-10">
        <div className="md:col-span-5">
          <div className="mb-5">
            <img
              src="https://customer-assets.emergentagent.com/job_cinematic-minimal-1/artifacts/3kurmq5r_IMG_6229.jpg"
              alt="Insight Media Productions"
              className="h-16 w-auto object-contain"
            />
          </div>
          <p className="text-white/60 max-w-sm leading-relaxed">
            Impactful video production for nonprofits, podcasts, courses and
            purpose-driven brands.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="eyebrow text-white/40 mb-5">Navigate</p>
          <ul className="space-y-3 text-sm">
            <li><a href="#work" className="hover:text-[#E60000] transition-colors">Work</a></li>
            <li><a href="#services" className="hover:text-[#E60000] transition-colors">Services</a></li>
            <li><a href="#about" className="hover:text-[#E60000] transition-colors">About</a></li>
            <li><a href="#contact" className="hover:text-[#E60000] transition-colors">Contact</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="eyebrow text-white/40 mb-5">Get in touch</p>
          <ul className="space-y-3 text-sm">
            <li>
              <a
                href="mailto:Benny@insightmediallc.com"
                className="hover:text-[#E60000] transition-colors"
                data-testid="footer-email"
              >
                Benny@insightmediallc.com
              </a>
            </li>
            <li>
              <a
                href="tel:+15512064494"
                className="hover:text-[#E60000] transition-colors"
                data-testid="footer-phone"
              >
                551-206-4494
              </a>
            </li>
            <li>
              <a
                href="https://wa.me/15512064494"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#E60000] transition-colors"
                data-testid="footer-whatsapp"
              >
                WhatsApp →
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="px-6 md:px-12 lg:px-16 py-6 border-t border-[#1a1a1a] flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-white/40">
        <p>© {YEAR} Insight Media Productions LLC. All rights reserved.</p>
        <p className="eyebrow">Made with intent · NJ / NY</p>
      </div>
    </footer>
  );
}
